// utils/normalize.js
export const normalizeBreeds = (list) =>
  list.map((b) =>
    typeof b === 'string'
      ? { value: b, label: b }
      : {
          value: b.value ?? b.id ?? b.name,
          label: b.label ?? b.name ?? b.value,
        }
  );
